import { render } from "./RequestForm.vue?vue&type=template&id=982b78e0&scoped=true"
import script from "./RequestForm.vue?vue&type=script&lang=js"
export * from "./RequestForm.vue?vue&type=script&lang=js"

import "./RequestForm.vue?vue&type=style&index=0&id=982b78e0&scoped=true&lang=css"

import exportComponent from "C:\\Users\\DimmyMarcelissen\\WebstormProjects\\dividenduitkering\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-982b78e0"]])

export default __exports__